import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  TestimonialDetail,
  TestimonialIndexItem,
  TestimonialLandingMain
} from './testimonial-cms.models';

@Injectable({ providedIn: 'root' })
export class TestimonialCmsService {
  private readonly http = inject(HttpClient);
  private readonly testimonialsBaseUrl = `${environment.blobPrefix.replace(/\/+$/, '')}/testimonials`;

  getIndex(): Observable<TestimonialIndexItem[] | string[]> {
    return this.http.get<TestimonialIndexItem[] | string[]>(`${this.testimonialsBaseUrl}/index.json`, {
      transferCache: false
    });
  }

  getMain(): Observable<TestimonialLandingMain> {
    return this.http.get<TestimonialLandingMain>(`${this.testimonialsBaseUrl}/main.json`, {
      transferCache: false
    });
  }

  getBySlug(slug: string): Observable<TestimonialDetail> {
    return this.http.get<TestimonialDetail>(`${this.testimonialsBaseUrl}/${encodeURIComponent(slug)}.json`, {
      transferCache: false
    });
  }
}
